import { del, get, post } from '../..';
import { buildUrl } from '../../../utils';

export interface ICustomerManagerToken {
  token: string;
  domainId: number;
  expiresAt: string;
}

const CUSTOMER_MANAGER_TOKEN_PATH = '/v1/security/customer-manager/token';

export const fetchCustomerManagerTokens = () =>
  get<ICustomerManagerToken[]>(buildUrl(CUSTOMER_MANAGER_TOKEN_PATH));

export const generateCustomerManagerToken = (domainId: number) =>
  post<ICustomerManagerToken>(buildUrl(CUSTOMER_MANAGER_TOKEN_PATH), {
    domainId,
  });

export const deleteCustomerManagerToken = (domainId: number) =>
  del(buildUrl(`${CUSTOMER_MANAGER_TOKEN_PATH}/${domainId}`));
